(function () {
  const FIRST_VISIT_KEY = "first_visit_72";
  const FORM_ID_DESKTOP = "V7bS7U";
  const FORM_ID_MOBILE = "TLYgHH";
  const COOKIE_SUBMITTED = "kl_submitted_72";
  const COOKIE_SHOWN = "kl_shown_72";
  const POPUP_COOLDOWN_SECONDS = 12 * 60;
  function getFormId() {
    return window.matchMedia("(max-width: 767px)").matches
      ? FORM_ID_MOBILE
      : FORM_ID_DESKTOP;
  }
  function setCookie(name, value, maxAgeSeconds) {
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      "; Max-Age=" +
      maxAgeSeconds +
      "; Path=/; SameSite=Lax";
  }
  function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function pushDataLayerFirstVisit() {
    if (!window.dataLayer) window.dataLayer = [];
    window.dataLayer.push({
      event: "first_visit_72",
      debug_timestamp: new Date().toISOString(),
    });
  }
  function openKlaviyoPopup() {
    if (getCookie(COOKIE_SUBMITTED) === "1") return;
    if (getCookie(COOKIE_SHOWN) === "1") return;
    const formId = getFormId();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", formId]);
    setCookie(COOKIE_SHOWN, "1", POPUP_COOLDOWN_SECONDS);
  }
  function klaviyoTrackFirstVisit(firstVisitAtIso) {
    if (!firstVisitAtIso) return;
    let tsIso = firstVisitAtIso;
    try {
      tsIso = new Date(firstVisitAtIso).toISOString();
    } catch {}
    if (window.klaviyo && typeof window.klaviyo.track === "function") {
      window.klaviyo.track("First Visit", {
        first_visit_at: tsIso,
        debug: true,
      });
      return;
    }
    if (window._learnq) {
      window._learnq.push([
        "track",
        "First Visit",
        {
          first_visit_at: tsIso,
          debug: true,
        },
      ]);
      return;
    }
    console.error("[Klaviyo] ERROR: Klaviyo not loaded");
  }

  function klaviyoIdentifyFirstVisit(firstVisitAtIso) {
    if (!firstVisitAtIso || !window._learnq) return;

    let tsIso = firstVisitAtIso;
    try {
      tsIso = new Date(firstVisitAtIso).toISOString();
    } catch {}

    window._learnq.push([
      "identify",
      {
        first_visit_at: tsIso,
      },
    ]);
  }

  function trackFirstVisit() {
    const raw = localStorage.getItem("vx_state");
    if (!raw) return;

    let vx;
    try {
      vx = JSON.parse(raw);
    } catch {
      return;
    }

    const isPromo = vx?.state === "promo";
    const notSubscribed = vx?.subscribed !== true;

    if (isPromo && notSubscribed) {
      openKlaviyoPopup();
    }
    if (localStorage.getItem(FIRST_VISIT_KEY)) return;
    try {
      const firstVisitAtMs = new Date(vx.firstVisitAt).getTime();
      if (Number.isFinite(firstVisitAtMs)) {
        const diffMs = Date.now() - firstVisitAtMs;
        if (diffMs >= 60000) {
          localStorage.setItem(FIRST_VISIT_KEY, "true");
          return;
        }
      }
    } catch {}
    const firstVisitAtIso =
      (vx?.firstVisitAt && new Date(vx.firstVisitAt).toISOString()) ||
      new Date().toISOString();
    pushDataLayerFirstVisit();
    if (isPromo && notSubscribed) {
      klaviyoTrackFirstVisit(firstVisitAtIso);
      klaviyoIdentifyFirstVisit(firstVisitAtIso);
    }
    localStorage.setItem(FIRST_VISIT_KEY, "true");
  }
  document.addEventListener("vx:visitor", trackFirstVisit);
  window.addEventListener("klaviyoForms", function (e) {
    if (e?.detail?.type === "submit") {
      setCookie(COOKIE_SUBMITTED, "1", 30 * 24 * 60 * 60);
      document.dispatchEvent(new Event("vx:subscribe", { bubbles: true }));
    }
  });
})();